"use client";

import Link from "next/link";
import { useState } from "react";
import { GateGlyph } from "./gate-glyph";
import { cn } from "@/lib/utils";

interface LogoProps {
  className?: string;
  showWordmark?: boolean;
  size?: number;
  animated?: boolean;
  onClick?: () => void;
}

/**
 * Brand lockup: the stroke-drawn gate glyph + lowercase "moongate" wordmark
 * (Lexend), vertically centered on each other. Hovering scales the whole
 * lockup and replays the gate-draw animation (remount via the `replay` key).
 */
export function Logo({ className, showWordmark = true, size = 22, animated = true, onClick }: LogoProps) {
  const [replay, setReplay] = useState(0);

  return (
    <Link
      href="/"
      aria-label="moongate home"
      onClick={onClick}
      onMouseEnter={() => animated && setReplay((c) => c + 1)}
      className={cn(
        // Lift the whole lockup (glyph + text together) so it sits centered in
        // the navbar; the wordmark keeps its own offset to align with the glyph.
        "group inline-flex -translate-y-[2px] items-center gap-2 transition-transform duration-300 ease-out hover:scale-105",
        className,
      )}
    >
      <GateGlyph key={replay} size={size} animated={animated} className="text-primary dark:text-white" />
      {showWordmark && (
        <span
          className="translate-y-[3px] bg-gradient-to-r from-foreground/70 via-foreground to-foreground/70 bg-clip-text text-2xl font-semibold lowercase leading-[1.4] tracking-[-0.04em] text-transparent"
          style={{ fontFamily: "var(--font-lexend)" }}
        >
          moongate
        </span>
      )}
    </Link>
  );
}
